module.exports = __webpack_public_path__ + "static/img/news_program_4.296c9d86.png";